import { ReportData } from '../../../types/reportData';

export interface DataSource {
  loaded: boolean;
  width?: number;
  height?: number;
  chart?: string;
}

export const CHART_DEFAULTS = {
  OPTIONS: {
    colors: ['#A6CFE5', '#D6F5DF', '#1A5A87'],
    pieSliceTextStyle: {
      color: '#0c3866',
    },
    legend: {
      position: 'top'
    },
    chartArea: {
      top: 40,
      bottom: 20,
      left: 20,
      right: 20,
    },
    titleTextStyle: {
      color: 'a1a3a4'
    }
  }
};

export interface GenerateChartsProps {
  updateData: (key: string, data: DataSource) => void;
  questionData: ReportData[];
}
